import fr from 'facet-rest';
import { fullDateTimeNoSeconds } from 'Consts/DateFormats';
import AssignToMeButton
  from 'Components/AdvisorApp/Viewport/ApexAdminPortal/IdentityVerificationReviews/AssignToMeButton/AssignToMeButton';
import TextField from 'Components/ComponentLibrary/Components/Uncategorized/TextField';

export const IdentityVerificationReviewsTable = fr.metaOverride()
  .overrideAll({
    readonly: true,
    _hideLabel: true,
    _customProps: {
      noWrap: true,
      hasTooltip: true,
    },
  })
  .nameOverride('householdId', { hidden: false, prompt: 'HHID' })
  .nameOverride('dateSubmitted', {
    prompt: 'Date',
    _displayTime: true,
    _formatString: fullDateTimeNoSeconds,
  })
  .nameOverride('assignedTo', {
    hidden: false,
    readonly: false,
    _spreadPropNames: ['resource'],
    _component: () => AssignToMeButton,
  });

export const getIdentityVerificationReviewsTableFilters = (collection, householdSearch) => [
  {
    name: 'householdId',
    overrideOptions: householdSearch ? householdSearch.map(search => ({
      name: `${search.attributes.primaryClientFirstName} ${search.attributes.primaryClientLastName} [${search.id}]`,
      value: search.id.toString(),
    })) : [],
    query: 'getIdentityVerificationReviews',
    _setQueryParam: true,
  },
  {
    name: 'accountTitle',
    query: 'getIdentityVerificationReviews',
    overrideOperators: ['like'],
  },
  {
    name: 'bankAccountTitle',
    query: 'getIdentityVerificationReviews',
    overrideOperators: ['like'],
  },
  {
    name: 'status',
    query: 'getIdentityVerificationReviews',
    overrideOperators: ['in'],
  },
  {
    name: 'startDate',
    query: 'getIdentityVerificationReviews',
  },
  {
    name: 'endDate',
    query: 'getIdentityVerificationReviews',
  },
  {
    name: 'agentId', // picklist
    overrideOptions: collection
      .meta()
      .field('assignedTo')
      .options()
      .list()
      .map(option => ({
        name: option.attr('prompt'),
        value: option.attr('id'),
      })),
    query: 'getIdentityVerificationReviews',
  },
];

export const IdentityVerificationReviewDetailsDialogOverride = fr.metaOverride()
  .overrideAll({
    readonly: true,
    _hideLabel: false,
    _customProps: {
      noWrap: true,
    },
  })
  .nameOverride('bankAccountName', {
    prompt: 'Name',
  })
  .nameOverride('bankAccountRoutingNumber', {
    prompt: 'Routing Number',
  })
  .nameOverride('bankAccountNumber', {
    prompt: 'Account Number',
  })
  .nameOverride('clearingHouseAccountName', {
    prompt: 'Name',
  })
  .nameOverride('reviewComment', {
    _hideLabel: false,
  })
  .nameOverride('assignedTo', {
    prompt: 'Assign To',
    readonly: false,
  });

export const IdentityVerificationDecisionDialogOverride = fr.metaOverride()
  .nameOverride('comment', {
    _component: () => TextField,
    multiline: true,
    rows: 5,
    maxRows: 5,
    _customProps: {
      placeholder: 'Enter reason for approval or rejection',
    },
  });

export const IdentityVerificationMatchResultsBaseOverride = fr.metaOverride()
  .overrideAll({
    readonly: true,
    _hideLabel: true,
    _customProps: {
      noWrap: true,
    },
  });

export const IdentityVerificationMatchResultsNoMatchOverride = fr.metaOverride()
  .overrideAll({
    readonly: true,
    _hideLabel: true,
    _customProps: {
      color: 'red',
      fontWeight: 500,
      noWrap: true,
    },
  });
